import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import ThemeContext from '../../contexts/ThemeContext';
import Datepicker from '../Datepicker';
import Label from '../Label';
import { Section, InputWithIcon } from '../PrebookingSharedComponents';
import { CalendarIcon } from '../PrebookingIcons';
import { ErrorText } from './shared';
import i18n from '../../i18n';

const DeliveryDateRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const DatePickerWrapper = styled.div`
  flex: 0 0 auto;
  min-width: 200px;
`;

const DeliveryDatePicker = ({ selected, onChange, error }) => {
  const { colors } = useContext(ThemeContext);
  const borderColor = error ? colors.errorColor : colors.webDefaultInputBorderColor;

  return (
    <Section>
      <Label text={i18n('translation_order_delivery_date')} required />
      <DeliveryDateRow>
        <DatePickerWrapper>
          <InputWithIcon hasIcon>
            <div className="input-icon">
              <CalendarIcon color={colors.iconAccentColor} size={20} />
            </div>
            <Datepicker
              showLabel={false}
              name="desiredDeliveryDate"
              selected={selected}
              placeholderText="DD.MM.20YY"
              minDate={new Date()}
              onChange={onChange}
              customHeight="40px"
              customBorder={`1px solid ${borderColor}`}
              customPadding="8px 8px 8px 40px"
            />
          </InputWithIcon>
        </DatePickerWrapper>
      </DeliveryDateRow>
      {error && <ErrorText>{i18n(error)}</ErrorText>}
    </Section>
  );
};

DeliveryDatePicker.propTypes = {
  selected: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default DeliveryDatePicker;
